import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useModalManager from '@hooks/useModalManager';
import { Button } from '@ui';
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import FormDataPreview from '../../../Formular/FormDataPreview';

const BookingToClubMemberAssistant = dynamic(() =>
    import('../../BookingToClubMemberAssistant').then((m) => m.BookingToClubMemberAssistant)
);

interface Props {
    bookingId: number;
    eventId: number;
    formDataId: number;
    /** Form behind the event, if any — only then can the assistant offer a field mapping. */
    formId?: number | null;
    /** Called after the assistant created or merged the member, so the list can refresh. */
    onMemberChanged?: () => void;
}

// Modal body for a booking's form data: the create/update-member action on top, the submitted values below.
const BookingFormDataModal = ({ bookingId, eventId, formDataId, formId, onMemberChanged }: Props) => {
    const { t } = useTranslation('bookings');
    const { addModal, removeModal } = useModalManager();

    // Opens the shared booking-to-member assistant, scoped to this single booking.
    const handleOpenAssistant = () =>
        addModal({
            title: t('booking.list.modals.createMember.title'),
            content: (id) => (
                <BookingToClubMemberAssistant
                    eventId={eventId}
                    formId={formId ?? undefined}
                    bookingIds={[bookingId]}
                    callback={() => {
                        removeModal(id);
                        onMemberChanged?.();
                    }}
                />
            ),
            size: 70,
            show: true
        });

    return (
        <div>
            <Button block className="tw-mb-4" onPress={handleOpenAssistant}>
                <FontAwesomeIcon icon={faUserPlus} className="tw-mr-2" />
                {t('booking.list.rowActions.createOrUpdateMember')}
            </Button>
            <FormDataPreview formDataId={formDataId} />
        </div>
    );
};

export default BookingFormDataModal;
